import { useInputNew } from "@UI/InputNew/useInputNew";
import { useEffect, useMemo, useState } from "react";
import s from './index.module.css';
import { useAddAlert } from "@/hooks/useAddAlert";
import Preloader from "@UI/Preloader";
import { useSelector } from "react-redux";
import { checkJournalStore } from "@/services/JournalStoreUpdateService";
import { InputSelect } from "@UI/InputNew";
import InputWhite from '@pages/Admin/Mailings/Create/InputWhite';
import Button from '../../../UI/Button';
import { useDispatch } from 'react-redux';
import { closeModal } from "@store/modalsSlise";
import TYPES from "@modals/TYPES";

const EMPTY_TYPE = '';

const JournalLessonTypeInfo = ({
    data
}) => {
    const dispatch = useDispatch();
    const [id, setId] = useState(data.data?.id ?? EMPTY_TYPE);
    const [comment, setComment] = useState(data.data?.comment ?? '');
    const addAlert = useAddAlert();
    const statusJournalStore = useSelector(store => store.journal.status);
    useEffect(() => {
        checkJournalStore().catch(errors => {
            addAlert({
                title: 'Ошибка!',
                text: errors.join(' '),
                type: 'error'
            })
        })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const lessonTypes = useSelector(
        store => store.journal.lessonTypes
    );

    const options = useMemo(() => {
        return [{
            label: 'Без типа',
            value: EMPTY_TYPE
        }, ...lessonTypes.map(el => ({
            label: el.name,
            value: el.id
        }))];
    }, [lessonTypes]);

    const [bindTypes] = useInputNew({
        value: id,
        onChange: (e) => {
            setId(e);
            const comment = lessonTypes.find(el => el.id === e)?.comment;
            if (comment)
                setComment(comment);
        },
        options,
    });

    return (<>
        <div className={s.title}>
            { data.data?.id ? 'Изменить ' : 'Добавить ' }тип урока
        </div>
        <div className={s.body}>
            {
                statusJournalStore === 1 ?
                <Preloader /> :
                <>
                    <div className={s.block}>
                        <p>Тип поля</p>
                        <InputSelect
                            newDesign
                            className={s.select}
                            { ...bindTypes }
                        />
                    </div>
                    <div className={s.block}>
                        <div className={s.text}>
                            <p>Комментарий</p>
                            <InputWhite
                                className={s.customDatepicker}
                                value={comment}
                                onChange={(e) => setComment(e.target.value)}
                            />
                        </div>
                    </div>
                    <Button
                        newDesign
                        className={s.add}
                        action={() => {
                            data.action(id || null, comment);
                            dispatch(
                                closeModal({
                                    type: TYPES.JOURNAL_LESSON_TYPE_INFO
                                })
                            )
                        }}
                    >Сохранить</Button>
                </>
            }
        </div>
    </>)
}

export default JournalLessonTypeInfo;
